import {createReducer, createAsyncThunk} from '@reduxjs/toolkit'
import brandService from '../../services/brand.service'
import BrandProps from '../../props_reusable/brand'
import utils from '../../utils'

const initialState: BrandProps = {
  logo: '',
}

export const fetchLogo = createAsyncThunk(
  'fetchLogo',
  (orderGUID: string, thunkApi) => {
    return brandService
      .getBrandLogo<string>(orderGUID)
      .then(utils.generateBase64EncodedURL)
      .catch(() => {
        throw thunkApi.rejectWithValue('invalid_image')
      })
  },
)

const brandReducer = createReducer(initialState, builder => {
  builder.addCase(fetchLogo.fulfilled, (state, action) => {
    return {
      ...state,
      logo: action.payload as string,
    }
  })
  builder.addCase(fetchLogo.rejected, (state, action) => {
    return {
      ...state,
      logo: action.payload as string,
    }
  })
})

export default brandReducer
